import { createFileRoute } from '@tanstack/react-router';
import { DocPage } from '@/components/docs/DocPage';
import { tokensDocTitle, tokensDocDescription, tokensDocSections } from '@/content/docs/tokens';

export const Route = createFileRoute('/_admin/docs/tokens')({
  component: DocsTokensPage,
});

function DocsTokensPage() {
  return (
    <DocPage
      title={tokensDocTitle}
      description={tokensDocDescription}
      sections={tokensDocSections}
    />
  );
}
